/* Wired storefront asset. Load with defer, followed by wired-affiliate-consent.js.
   Tracking starts only when Shopify allows analytics AND marketing attribution. */
window.WiredAffiliate = (() => {
  const APP = 'https://affiliates.wiredsnowboards.com';
  const DAYS = 30; // Match the app's configured attribution window.
  const KEY = 'wired-affiliate-v1';
  let active = false;
  let generation = 0;
  let listener;
  let pending = Promise.resolve();
  const root = () => (window.Shopify?.routes?.root || '/');
  async function saveCart(token) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    try { const response = await fetch(root() + 'cart/update.js', {
    signal: controller.signal,
    method: 'POST', headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({attributes: {wired_referral: token}})
    });
    if (!response.ok) throw new Error('Unable to save referral');
    } finally { clearTimeout(timer); }
  }
  async function start() {
    if (active) return pending;
    active = true;
    const run = ++generation;
    const previous = pending;
    pending = (async () => {
      await previous;
      if (!active || run !== generation) return;
      try {
        const url = new URL(location.href);
        const fresh = url.searchParams.get('wired_ref');
        let saved;
        try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (_) {}
        if (fresh && /^[A-Za-z0-9_-]{40,60}$/.test(fresh)) {
          saved = {token: fresh, expires: Date.now() + DAYS * 86400000};
          localStorage.setItem(KEY, JSON.stringify(saved));
        }
        url.searchParams.delete('wired_ref');
        history.replaceState(null, '', url.pathname + url.search + url.hash);
        if (!saved || !/^[A-Za-z0-9_-]{40,60}$/.test(saved.token || '') || !Number.isFinite(saved.expires) || saved.expires <= Date.now()) {
          localStorage.removeItem(KEY); await saveCart(''); return;
        }
        // Last referral wins. The server independently enforces token validity and expiry.
        await saveCart(saved.token);
        if (!active || run !== generation) return;
        let visit = sessionStorage.getItem(KEY);
        if (!visit) {visit = crypto.randomUUID(); sessionStorage.setItem(KEY, visit);}
        fetch(APP + '/track/visit', {method: 'POST', mode: 'cors', credentials: 'omit',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({token: saved.token, visit})}).catch(() => {});
      } catch (_) { console.warn('Wired referral tracking unavailable. Checkout remains available.'); }
    })();
    // Delay normal checkout form submission until initial attribution update settles.
    listener = async event => {
      const form = event.target;
      if (!active || !(form instanceof HTMLFormElement)) return;
      const action = new URL(form.action, location.href);
      if (action.origin !== location.origin || !action.pathname.endsWith('/cart')) return;
      const button = event.submitter;
      if (button?.name !== 'checkout') return;
      if (form.dataset.wiredReady === '1') return;
      event.preventDefault(); await pending;
      form.dataset.wiredReady = '1';
      form.requestSubmit(button);
    };
    document.addEventListener('submit', listener);
    return pending;
  }
  async function revoke() {
    active = false;
    ++generation;
    document.removeEventListener('submit', listener);
    const previous = pending;
    pending = (async () => {
      await previous;
      try {localStorage.removeItem(KEY); sessionStorage.removeItem(KEY);} catch (_) {}
      try {await saveCart('');} catch (_) {console.warn('Wired referral cleanup unavailable.');}
    })();
    return pending;
  }
  return {start, revoke};
})();
